import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-325c0263"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "standard"
};
const _hoisted_2 = {
  class: "td"
};
const _hoisted_3 = {
  class: "product"
};
const _hoisted_4 = {
  class: "image-badge-wrapper"
};
const _hoisted_5 = {
  class: "image-wrapper"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["id"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tooltip-description-revenue-share"
}, "Revenue Share", -1));
const _hoisted_9 = {
  class: "info"
};
const _hoisted_10 = {
  class: "name"
};
const _hoisted_11 = {
  class: "asin-sku"
};
const _hoisted_12 = {
  class: "standard"
};
const _hoisted_13 = {
  class: "sub-cells cogs-column"
};
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = {
  key: 1,
  style: {
    "text-align": "center",
    "color": "#595959 !important",
    "font-family": "Figtree",
    "font-size": "14px !important",
    "font-weight": "500 !important"
  }
};
const _hoisted_16 = {
  class: "price-field-wrapper"
};
const _hoisted_17 = {
  class: "sub-cell",
  style: {
    "width": "37.5%",
    "justify-content": "flex-end",
    "padding": "8px"
  }
};
const _hoisted_18 = {
  class: "title"
};
const _hoisted_19 = {
  style: {
    "text-align": "end",
    "color": "#595959 !important",
    "font-family": "Figtree",
    "font-size": "14px !important",
    "font-weight": "500 !important"
  }
};
const _hoisted_20 = {
  class: "standard-product-search"
};
const _hoisted_21 = {
  class: "standard"
};
const _hoisted_22 = {
  class: "title"
};
const _hoisted_23 = {
  key: 1,
  style: {
    "text-align": "start"
  }
};
const _hoisted_24 = {
  key: 0,
  class: "standard"
};
const _hoisted_25 = {
  class: "standard"
};
const _hoisted_26 = {
  class: "sub-cell-unit",
  style: {
    "justify-content": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_popover = _resolveComponent("b-popover");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_b_form_select = _resolveComponent("b-form-select");
  const _component_product_segment_filter = _resolveComponent("product-segment-filter");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_fiscal_code_filter = _resolveComponent("fiscal-code-filter");
  return _openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(['app-row', {
      selected: $props.selected
    }]),
    onClick: _cache[21] || (_cache[21] = (...args) => $options.onSelect && $options.onSelect(...args))
  }, [_createElementVNode("td", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $options.image,
    alt: ""
  }, null, 8, _hoisted_6)]), _createElementVNode("div", {
    id: `tooltip-target-revenue-share-${$options.computedId}`,
    class: "percentage-badge"
  }, _toDisplayString($props.item.revenue_share_percent != null ? $props.item.revenue_share_percent + '%' : '0%'), 9, _hoisted_7)]), _createVNode(_component_b_popover, {
    target: `tooltip-target-revenue-share-${$options.computedId}`,
    triggers: "hover",
    customClass: "wrap-with-popover revenue-share-popover"
  }, {
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  }, 8, ["target"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString($props.item.product_name), 1), _createElementVNode("div", _hoisted_11, _toDisplayString($options.asinSku), 1)])])])]), _createElementVNode("td", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
    class: _normalizeClass(["sub-cell", {
      selected: $props.focusedCell === `${$options.computedId}-cost-input`
    }]),
    style: {
      "width": "32%",
      "justify-content": "flex-end",
      "padding": "8px"
    },
    onClick: _cache[5] || (_cache[5] = $event => $options.focusInput(`${$options.computedId}-cost-input`))
  }, [_createElementVNode("div", _hoisted_14, [$props.focusedCell === `${$options.computedId}-cost-input` ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    type: "number",
    ref: `${$options.computedId}-cost-input`,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.v$.cost.$model = $event),
    onFocus: _cache[1] || (_cache[1] = $event => $options.initModifiedValue('cost')),
    onInput: _cache[2] || (_cache[2] = $event => $options.onUpdateCost($event)),
    class: _normalizeClass(["title unit-color", {
      'isUnvalid': !$data.isValid
    }]),
    style: {
      "text-align": "end",
      "border": "none",
      "outline": "none",
      "width": "100%",
      "height": "100%"
    },
    onBlur: _cache[3] || (_cache[3] = $event => $options.onUpdate('cost', `${$options.computedId}-cost-input`)),
    onKeyup: _cache[4] || (_cache[4] = _withKeys($event => $options.focusNextCell(`${$options.computedId}-currency`), ["enter"])),
    inputmode: "numeric",
    pattern: "[0-9]*\\.?[0-9]{1,2}*"
  }, null, 34)), [[_vModelText, $setup.v$.cost.$model]]) : (_openBlock(), _createElementBlock("span", _hoisted_15, [_createVNode(_component_currency_value, {
    value: $props.item.cost,
    precision: "2",
    currency: $props.item.currency
  }, null, 8, ["value", "currency"])]))])], 2), _createElementVNode("div", {
    class: _normalizeClass(["sub-cell", {
      selected: $props.focusedCell === `${$options.computedId}-currency`
    }]),
    style: {
      "width": "30.5%"
    },
    onClick: _cache[8] || (_cache[8] = $event => $options.focusInput(`${$options.computedId}-currency`))
  }, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_b_form_select, {
    ref: `${$options.computedId}-currency`,
    options: $data.currencies,
    modelValue: $options.computedCurrency,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $options.computedCurrency = $event),
    class: "currency-selector",
    onKeydown: _withKeys(_withModifiers($options.handleEnterKey, ["prevent"]), ["enter"]),
    onChange: _cache[7] || (_cache[7] = $event => $options.handleCurrencyDropdownChange($event))
  }, null, 8, ["options", "modelValue", "onKeydown"])])], 2), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString($options.formattedLastModified), 1)])])])]), _createElementVNode("td", _hoisted_20, [_createElementVNode("div", {
    class: _normalizeClass(["sub-cell-unit-product-segment", {
      selected: $props.focusedCell === `${$options.computedId}-product-segment`,
      'is-search-active': $data.isSearchActive
    }]),
    onClick: _cache[11] || (_cache[11] = $event => $options.focusInput(`${$options.computedId}-product-segment`))
  }, [_createElementVNode("div", {
    class: "select-wrapper-product-segment",
    ref: `${$options.computedId}-product-segment`,
    style: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_createVNode(_component_product_segment_filter, {
    value: $options.computedProductSegment,
    options: $options.computedProductSegmentList,
    placeholder: "Assign",
    uniqueToolTipID: `${$options.computedId}-product-segment`,
    onChange: _cache[9] || (_cache[9] = $event => $options.handleProductSegmentDropdownChange($event, 'product_segment')),
    onShowTableCell: $options.showTableCell,
    onHideTableCell: $options.hideTableCell
  }, null, 8, ["value", "options", "uniqueToolTipID", "onShowTableCell", "onHideTableCell"]), !$data.isSearchActive ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "icon-container-product-segment-delete",
    onClick: _cache[10] || (_cache[10] = $event => $options.handleDeleteProductSegment('product_segment'))
  }, [_createVNode(_component_app_icon, {
    icon: "delete-segment"
  })])) : _createCommentVNode("", true)], 512)], 2)]), _createElementVNode("td", _hoisted_21, [_createElementVNode("div", {
    class: _normalizeClass(["sub-cell-unit", {
      selected: $props.focusedCell === `${$options.computedId}-external-sku-input`
    }]),
    onClick: _cache[18] || (_cache[18] = $event => $options.focusInput(`${$options.computedId}-external-sku-input`))
  }, [_createElementVNode("div", _hoisted_22, [$props.focusedCell === `${$options.computedId}-external-sku-input` ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    type: "text",
    ref: `${$options.computedId}-external-sku-input`,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.modifiedItemValue = $event),
    onFocus: _cache[13] || (_cache[13] = $event => $options.initModifiedValue('external_sku')),
    class: "title",
    style: {
      "text-align": "start",
      "border": "none",
      "outline": "none",
      "width": "100%",
      "height": "100%"
    },
    onBlur: _cache[14] || (_cache[14] = $event => $options.onUpdate('external_sku', `${$options.computedId}-external-sku-input`)),
    onKeyup: _cache[15] || (_cache[15] = _withKeys($event => $options.focusNextCell(`${$options.computedId}-vendor-sku-input`), ["enter"])),
    inputmode: "text",
    pattern: "[a-zA-Z0-9]*",
    onInput: _cache[16] || (_cache[16] = $event => $options.handleSpecialInputPattern($event, 'external_sku')),
    onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
  }, null, 544)), [[_vModelText, $data.modifiedItemValue]]) : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString($props.item.external_sku), 1))])], 2)]), $props.accountProvider === 'Amazon Vendor Central' ? (_openBlock(), _createElementBlock("td", _hoisted_24, [_createElementVNode("div", {
    class: _normalizeClass(["sub-cell-unit", {
      selected: $props.focusedCell === `${$options.computedId}-fiscal-code`
    }]),
    onClick: _cache[20] || (_cache[20] = $event => $options.focusInput(`${$options.computedId}-fiscal-code`))
  }, [_createElementVNode("div", {
    class: "select-wrapper",
    ref: `${$options.computedId}-fiscal-code`
  }, [_createVNode(_component_fiscal_code_filter, {
    disabled: false,
    value: $options.computedFiscalCode,
    options: $data.fiscal_codes,
    placeholder: "Select product tax code",
    onChange: _cache[19] || (_cache[19] = $event => $options.handleDropdownChange($event, 'fiscal_code'))
  }, null, 8, ["value", "options"])], 512)], 2)])) : _createCommentVNode("", true), _createElementVNode("td", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_app_icon, {
    icon: "edit-cogs"
  })])])], 2);
}